var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"turn-your-screen"},[_c('i',{staticClass:"el-icon-arrow-left"}),_c('h1',[_c('span',[_vm._v("Turn your screen")])])])}]

export { render, staticRenderFns }